module.exports = __webpack_public_path__ + "static/media/poste_5.e754fc9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_5.jpg
// module id = 262
// module chunks = 0